import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {

  copyright = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    const d = new Date();
    this.copyright = d.getUTCFullYear();
  }

  /**
   * Go to the privacy page
   */
  onPrivacyClick(): void {
    this.service.setPage('about/privacy');
    this.router.navigateByUrl(this.router.url + '(popup:help)');
  }
}
